/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import colors from "../../base/colors";

const { transparent, primary, background } = colors;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      width: "100%",
      maxWidth: "446px",
      "& fieldset, &:hover fieldset": {
        borderColor: primary.main,
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 0,
      },
      "& .MuiInputBase-input": {
        color: primary.main, // Text color when typing
        fontFamily: "Inter", // Custom font
        fontSize: "1rem",
        backgroundColor: "transparent",
      },
      // 2. Default Label Styling (when resting or floating)
      "& .MuiInputLabel-root": {
        color: primary.main, // Custom green label color
        fontFamily: "Inter",
      },
      // Label style when focused
      "& .MuiInputLabel-root.Mui-focused": {
        color: primary.main,
      },
    },
  },
};

export default textField;
